// Attaches a QuantityPicker to the +/- control on each product card.
//
// This file is loaded with `async` (layout/theme.liquid), so it can execute
// either before or after the document finishes parsing. Registering a
// DOMContentLoaded listener unconditionally therefore loses the race whenever
// the script arrives late — the event has already fired, the listener never
// runs, and no card on the page gets a working quantity picker. Cached loads
// worked, cold loads did not, which made it look intermittent.

(function () {
  var ATTACHED = 'quantityPickerAttached';

  function attachQuantityPickerToProduct(product) {
    // Cards can be visited more than once — by the initial sweep and again by
    // the observer — and a second QuantityPicker on the same element binds a
    // duplicate set of click handlers, so each tap counts twice.
    if (!product || product.dataset[ATTACHED]) return;

    var quantityPickerElement = product.querySelector('.quantity-selector.quantity-selector--product');
    if (!quantityPickerElement) return;

    // Multi-variant cards render a "Choose options" link instead of a picker,
    // so a missing element is normal and not an error.
    if (typeof window.QuantityPicker !== 'function') return;

    product.dataset[ATTACHED] = '1';
    product.quantityPicker = new window.QuantityPicker(quantityPickerElement);
  }

  function attachWithin(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('.product-item')) attachQuantityPickerToProduct(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.product-item').forEach(attachQuantityPickerToProduct);
    }
  }

  function attachAll() {
    document.querySelectorAll('.product-item').forEach(attachQuantityPickerToProduct);
  }

  // Cards can arrive after load: carousels hydrate into `.scroller`, and the
  // cart/quick-view re-render their contents. The previous version only looked
  // at added nodes that were themselves a `.scroller`, so a card added anywhere
  // else — or a `.scroller` whose cards arrive in a later mutation — was
  // missed. Walk whatever was added instead, and let the dataset flag above
  // keep it idempotent.
  function observeProductListChanges() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'childList') return;
        mutation.addedNodes.forEach(attachWithin);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    attachAll();
    observeProductListChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Already parsed — the async script arrived after DOMContentLoaded, which
    // is the case the old code silently dropped.
    init();
  }
})();
